import { NgForm } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MfaService } from '../service/mfa.service';
import { UserService } from '../service/user.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthService } from '../service/auth.service';
import { NgOtpInputComponent } from 'ng-otp-input';

@Component({
  selector: 'app-mfa',
  templateUrl: './mfa.component.html',
  styleUrls: ['./mfa.component.scss'],
})
export class MfaComponent implements OnInit, OnDestroy {
  isLoading = false;
  testSite = false;
  secret: any;
  qrImg: any;
  userData: any;
  hasSeed = false;
  hasPass: any;
  error: any;
  userSub: any;

  theCode:any;
  @ViewChild(NgOtpInputComponent, { static: false}) ngOtpInputRef?:NgOtpInputComponent;

  constructor(
    private authService: AuthService,
    private mfaService: MfaService,
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.userSub = this.userService.userData.subscribe((userData) => {
      //console.log(userData);
      if (userData) {
        this.userData = userData;
        if (!userData.mfa_seed) {
          this.mfaService.generateSecret().subscribe((responseData) => {
            this.qrImg = responseData.qrImg;
            this.secret = responseData.code;
            this.isLoading = false;
          });
        } else {
          this.isLoading = false;
          this.hasSeed = true;
        }

        if (userData.mfa_pass) {
          this.hasPass = true;
        }
      }
    });
  }

  onSubmit(form: NgForm) {
    this.isLoading = false;
    if (this.theCode.length != 6) {
      return;
    } else {
      this.mfaService.auth(this.theCode).subscribe(
        (responseData) => {
          // success
          // add a cookie?

          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Code Accepted',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            toast: true,
          });
          this.userService.reset();
          this.userService.get().subscribe((userData: any) => {
            this.authService.user.next(userData);
            this.router.navigate(['/dashboard']);
          });
        },
        (errorMessage) => {
          this.error = errorMessage;
          this.ngOtpInputRef?.setValue(null);
          let eleId=this.ngOtpInputRef?.getBoxId(0);
            this.ngOtpInputRef?.focusTo(eleId);
          this.theCode = null;
          this.isLoading = false;
        }
      );
    }
  }

  onOtpChange($event:any){
    
    this.theCode = $event;
  }
  onBack() {
    this.hasSeed = false;
  }
  onContinue() {
    this.hasSeed = true;
  }
  ngOnDestroy(): void {
    this.userSub?.unsubscribe();
  }
}
